import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'

import { delay } from '@/lib/ui'
import { SplitWords } from '@/components/generals/split-words'

interface ClosingCtaProps {
    label: string
    title: string
    href: string
    action: string
    note: string
}

export const ClosingCta: FC<ClosingCtaProps> = ({
    label,
    title,
    href,
    action,
    note
}): ReactNode => {
    return (
        <section className='ed-wrap pt-[clamp(48px,6vw,88px)] pb-[clamp(52px,7vw,96px)]'>
            <div className='ed-label mb-[clamp(30px,4.5vw,60px)]' data-reveal='up'>
                {label}
            </div>

            <Link href={href} className='cta-link' data-reveal='words'>
                <div className='flex flex-wrap items-end justify-between gap-x-10 gap-y-8'>
                    <div className='ed-display'>
                        <SplitWords text={title} />
                    </div>

                    <div className='ed-mono cta-arrow flex items-center gap-3 pb-[clamp(6px,1.4vw,20px)] text-faint'>
                        {action}

                        <ArrowUpRight className='size-4' aria-hidden />
                    </div>
                </div>
            </Link>

            <p className='ed-body mt-[clamp(26px,3.4vw,44px)] max-w-[52ch]' data-reveal='up' style={delay(0.12)}>
                {note}
            </p>
        </section>
    )
}
